import React, { useState } from 'react';
import ProgressBar from '../components/ProgressBar';
import SubscriptionTiers from '../components/SubscriptionTiers';
import UserInfo from '../components/UserInfo';
import PaymentInfo from '../components/PaymentInfo';

interface Tier {
    id: string;
    name: string;
    price: string;
    features: string[];
}

const SubscriptionPage: React.FC = () => {
    const [step, setStep] = useState(0);
    const [selectedTier, setSelectedTier] = useState<Tier | null>(null);
    const [userInfo, setUserInfo] = useState<{ email: string; password: string } | null>(null);
    const [paymentInfo, setPaymentInfo] = useState<{
        cardName: string;
        cardNumber: string;
        expiry: string;
        cvv: string;
        billingAddress: string;
    } | null>(null);

    const handleSelectTier = (tier: Tier) => {
        setSelectedTier(tier);
        setStep(1);
    };

    const handleSubmitUserInfo = (info: { email: string; password: string }) => {
        setUserInfo(info);
        setStep(2);
    };

    const handleSubmitPayment = (info: {
        cardName: string;
        cardNumber: string;
        expiry: string;
        cvv: string;
        billingAddress: string;
    }) => {
        setPaymentInfo(info);
        // Here you would typically send all the collected information to your backend
        console.log('Subscription complete', { selectedTier, userInfo, paymentInfo: info });
        // For now, we'll just move to a "completed" step
        setStep(3);
    };

    //function for going back pages
    const handleGoBack = () => {
        setStep((prevStep) => Math.max(0, prevStep - 1));
    };

    return (
        <div className="container mx-auto px-4 py-4 flex flex-col h-full">
            <div className="mb-4">
                <ProgressBar step={step} onGoBack={handleGoBack} />
            </div>
            <div className="flex-grow overflow-hidden">
                {step === 0 && <SubscriptionTiers onSelectTier={handleSelectTier} selectedTier={selectedTier?.id || null} />}
                {step === 1 && <UserInfo onSubmitUserInfo={handleSubmitUserInfo} />}
                {step === 2 && <PaymentInfo onSubmitPayment={handleSubmitPayment} />}
                {step === 3 && (
                    <div className="text-center">
                        <h1 className="text-3xl font-bold text-terracotta font-cinzel mb-1">Subscription Complete!</h1>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SubscriptionPage;